import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=9bf07af2&"
import script from "./Button.vue?vue&type=script&lang=ts&"
export * from "./Button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EbookModal: require('/data/www/nvpa.org/nvpa/nuxt/components/ebook/Modal.vue').default})
